import BaseStore from './base'

const schema = {
  type: String,
  fieldIDs: String,
  'comment?': String,
  values: String,
  timestamp: Number
}

export default class AssessmentStore extends BaseStore {
  static get storageKey () { return 'tracker-assessments' }
  static get apiFunction () { return 'postAssessments' }
  static get rawSchema () { return schema }

  static deflate (d) {
    return {
      ...d,
      fieldIDs: d.fieldIDs ? d.fieldIDs.map(d => d.replace('-0', '')).join(',') : '',
      values: d.values ? JSON.stringify(d.values) : ''
    }
  }
}
